import React, { Component } from 'react';
import PropTypes from 'prop-types';
// jl-design-system
import { scrollTo } from 'jl-design-system/utils/scroll/scrollTo';
import { setNoScroll } from 'jl-design-system/utils/scroll/noScroll';
import LoadingSpinner from 'jl-design-system/components/loading-spinner/LoadingSpinner';
import classNames from 'classnames';
import styles from './loading-screen.scss';

export default class LoadingScreen extends Component {

  static propTypes = {
    disableModalAttributes: PropTypes.bool,
    isApps: PropTypes.bool,
    message: PropTypes.string,
    seeThrough: PropTypes.bool,
    show: PropTypes.bool,
  };

  static defaultProps = {
    disableModalAttributes: true,
    isApps: false,
    message: '',
    seeThrough: false,
    show: false,
  };

  componentDidMount() {
    const {
      show,
      disableModalAttributes,
    } = this.props;

    if (show) {
      this.timeout = setTimeout(() => {
        scrollTo(0);
        setNoScroll(true, disableModalAttributes);
      }, 0);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      show,
      disableModalAttributes,
    } = this.props;

    if (!prevProps.show && show) {
      this.timeout = setTimeout(() => {
        scrollTo(0);
        setNoScroll(true, disableModalAttributes);
      }, 0);
    }
    if (prevProps.show && !show) {
      this.timeout = setTimeout(() => {
        setNoScroll(false, disableModalAttributes);
      }, 0);
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    setNoScroll(false, this.props.disableModalAttributes);
  }

  render() {
    const {
      show,
      message,
      seeThrough,
      isApps,
    } = this.props;

    if (show) {
      return (
        <div
          className={classNames(styles.overlay, {
            [styles.seeThrough]: seeThrough,
            [styles.apps]: isApps,
          })}
          data-test="loading-screen"
        >
          <div className={styles.contentBox}>
            { message && <h2 className={styles.message}>{message}</h2> }
            <div className={styles.spinner}>
              <LoadingSpinner />
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}
